import {
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
  Divider,
  Typography,
} from "@mui/material";
import InputTextField from "../input/inputTextField";
import FilterSelect from "../select/filterSelect";
import InputDatePicker from "../input/inputDatePicker";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { leaveTypeApi } from "../../api/leave-type/leave-type.api";
import InputNewRangePicker from "../input/inputRankPicker";
import moment from "moment";
import CheckBoxCustom from "../checkbox/CheckBoxCustom";
import RadioCustom from "../radio/RadioCustom";
import { Description } from "@mui/icons-material";
import AutocompleteSelect from "../select/autoCompleteSelect";
import { EmployeeApi } from "../../api/employee/employee.api";
import { mockDataCurrency } from "../../utils/mockData";
import { degreeApi } from "../../api/degree/degree.api";
import { facultyApi } from "../../api/factulty/factulty.api";
import { leaveFormApi } from "../../api/leave-form/leave-form.api";
import { OnlineLeaveSubmissionApi } from "../../api/online-leave-submission/online-leave-submission.api";
import { dateToView } from "../../utils/date.utils";
import { leave_type_category_data } from "../../constants/enum";

interface WorkPermitPeriod {
  period_date: string[];
  description: string;
  ref_date: string;
}

interface FormComponentProps {
  inputValue: any;
  setInputValue: (value: any) => void;
  handleCheckValid: boolean;
  isCanEdit: boolean;
  permission: any;
  formGenerate: any;
  setInputPeriod?: (value: any) => void; // Optional prop
  formCode?: string;
}

const FormComponent: React.FC<FormComponentProps> = ({
  inputValue,
  setInputValue,
  handleCheckValid,
  isCanEdit,
  permission,
  formGenerate,
  setInputPeriod,
  formCode,
}) => {
  const { t } = useTranslation();

  const handleRangeDate = (section: string, field: string, value: any) => {
    if (section !== "") {
      setInputValue((prevState: any) => ({
        ...prevState,
        [section]: {
          ...prevState[section],
          [field]: [
            moment(value[0]).format("YYYY-MM-DD"),
            moment(value[1]).format("YYYY-MM-DD"),
          ],
        },
      }));
    } else {
      setInputValue((prevState: any) => ({
        ...prevState,
        [field]: [
          moment(value[0]).format("YYYY-MM-DD"),
          moment(value[1]).format("YYYY-MM-DD"),
        ],
      }));
    }
  };
  const handleClearRangeDate = (section: string, field: string, value: any) => {
    if (section !== "") {
      setInputValue((prevState: any) => ({
        ...prevState,
        [section]: {
          ...prevState[section],
          [field]: [],
        },
      }));
    } else {
      setInputValue((prevState: any) => ({
        ...prevState,
        [field]: [],
      }));
    }
  };

  const [dataFaculty, setDataFaculty] = useState([]);

  const [dataDegree, setDataDegree] = useState([]);

  const [dataSalaryRate, setDataSalaryRate] = useState([
    {
      id: "0-50,000",
      salary_rate: "0-50,000",
    },
    {
      id: "51,000-100,000",
      salary_rate: "51,000-100,000",
    },
  ]);

  const [dataParentStatus, setDataParentStatus] = useState([
    {
      id: "alived",
      name: "alived",
    },
    {
      id: "deaded",
      name: "deaded",
    },
  ]);

  const [dataLeaveForm, setDataLeaveForm] = useState([]);

  const [dataEmployee, setDataEmployee] = useState<any>([]);

  const [dataLeaveType, setDataLeaveType] = useState([]);

  const [dataLeaveApprove, setDataLeaveTypeApprove] = useState([]);

  const [inputWorkPermitPeriod, setInputWorkPermitPeriod] = useState<
    WorkPermitPeriod[]
  >([{ period_date: [], description: "", ref_date: "" }]);

  const [inputWorkPermitPeriodAmount, setInputWorkPermitPeriodAmount] =
    useState<number>(1);

  const handleChangePeriod = (
    index: number,
    field: keyof WorkPermitPeriod,
    value: any
  ) => {
    setInputWorkPermitPeriod((prevPeriod) =>
      prevPeriod.map((item, idx) =>
        idx === index ? { ...item, [field]: value } : item
      )
    );
  };

  useEffect(() => {
    setInputPeriod && setInputPeriod(inputWorkPermitPeriod);
  }, [inputWorkPermitPeriod]);

  useEffect(() => {
    if (inputValue?.operational_data?.time_work_permit) {
      setInputWorkPermitPeriod(
        inputValue?.operational_data?.time_work_permit ?? []
      );
    }
  }, [inputValue?.operational_data?.time_work_permit]);

  const updateRows = () => {
    setInputWorkPermitPeriod((prevPeriod) => {
      const newPeriod = [...prevPeriod];
      // Add rows if the amount is greater than current length
      while (newPeriod.length < inputWorkPermitPeriodAmount) {
        newPeriod.push({ period_date: [], description: "", ref_date: "" });
      }
      // Remove rows if the amount is less than current length
      newPeriod.length = inputWorkPermitPeriodAmount;
      return newPeriod;
    });
  };

  // Call updateRows when inputWorkPermitPeriodAmount changes
  useEffect(() => {
    updateRows();
  }, [inputWorkPermitPeriodAmount]);

  const handleChange = (section: string, field: string, value: any) => {
    if (field === "work_permit_amonth") {
      setInputWorkPermitPeriodAmount(value);
    }

    if (section !== "") {
      setInputValue((prevState: any) => ({
        ...prevState,
        [section]: {
          ...prevState[section],
          [field]: value,
        },
      }));
    } else {
      // Updating the field at the root level
      setInputValue((prevState: any) => ({
        ...prevState,
        [field]: value,
      }));
    }
  };

  const getLeaveType = async () => {
    const param = { limit: 100 };
    const res = await leaveTypeApi.getAllLeaveType(param);
    const data = res.data;
    if (data.status < 300) {
      setDataLeaveType(data.data.items);
    } else {
      setDataLeaveType([]);
    }
  };

  const getLeaveApprove = async () => {
    const param = {
      limit: 1000,
      leave_status: "approve third",
      for_cancel: true
      // leave_status: "approve_third"
    };
    const res =
      await OnlineLeaveSubmissionApi.getRequestLeaveSubmissionByEmployee(param);
    const data = res.data;
    if (data.status < 300) {
      setDataLeaveTypeApprove(data.data.items);
      console.log("data.data.items", data.data.items);
    } else {
      setDataLeaveTypeApprove([]);
    }
  };

  const fetchGetDegree = async () => {
    // const param = { limit: 1000 };
    await degreeApi.getDegree().then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setDataDegree(data.data);
      } else {
        setDataDegree([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  };

  const fetchGetFaculty = async () => {
    const param = { limit: 1000 };
    await facultyApi.listFaculty().then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setDataFaculty(data.data);
      } else {
        setDataFaculty([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  };

  const fetchGetAllLeaveForm = async () => {
    const param = { limit: 10000 };
    const res = await leaveFormApi.getAllLeaveForm(param);
    const data = res.data;
    if (data.status < 300) {
      setDataLeaveForm(data.data);
    } else {
      setDataLeaveForm([]);
    }
  };

  const getEmployee = async () => {
    const param = { limit: 1000 };
    const res = await EmployeeApi.list(param);
    const data = res.data;
    if (data.status < 300) {
      setDataEmployee(data.data.items);
    } else {
      setDataEmployee([]);
    }
  };

  const getOptions = (optionName: string) => {
    switch (optionName) {
      case "faculty":
        return dataFaculty.map((faculty: any) => ({
          value: faculty.id_faculty,
          label: faculty.faculty_name,
        }));
      case "degree":
        return dataDegree.map((degree: any) => ({
          value: degree.id_degree,
          label: degree.degree_name,
        }));
      case "salary_rate":
        return dataSalaryRate.map((salary_rate) => ({
          value: salary_rate.id,
          label: salary_rate.salary_rate,
        }));
      case "parent_status":
        return dataParentStatus.map((status) => ({
          value: status.id,
          label: status.name,
        }));
      case "leave_type":
        return dataLeaveType.map((leave_type: any) => ({
          value: leave_type.id_leave_type,
          label: leave_type.leave_type_name,
        }));
      case "leave_form":
        return dataLeaveForm.map((leave_form: any) => ({
          value: leave_form.id_leave_form,
          label: leave_form.leave_form_name,
        }));
      case "leave_type_category":
        return leave_type_category_data.map((item) => ({
          value: item.value,
          label: item.label,
        }));
      case "employee":
        return dataEmployee.map((employee: any) => ({
          value: employee.id_employee,
          label: employee.fullname,
        }));
      case "status":
        return [
          {
            value: 1,
            label: "ได้",
          },
          {
            value: 0,
            label: "ไม่ได้",
          },
        ];
      case "currency":
        return mockDataCurrency.map((employee: any) => ({
          value: employee.currency_name,
          label: employee.currency_name,
        }));
      case "leave_approve":
        return dataLeaveApprove.map((leave_approve: any) => ({
          value: leave_approve.id_leave,
          label: `${leave_approve.leave_type?.leave_type_name}, ${dateToView(
            leave_approve?.leave_start_date,
            false
          )} - ${dateToView(leave_approve?.leave_end_date)}`,
        }));
      default:
        return [];
    }
  };

  useEffect(() => {
    getLeaveType();
    getEmployee();
    fetchGetDegree();
    fetchGetFaculty();
    fetchGetAllLeaveForm();
    getLeaveApprove();
  }, []);

  // รีเซ็ตค่า field ที่ผูกกับรูปแบบฟอร์ม (เช่น หมวดหมู่การลา) เมื่อรูปแบบฟอร์มที่เลือกไม่ตรงเงื่อนไข
  // เพื่อไม่ให้ค่าเก่าค้างแล้วถูกส่งไป (รูปแบบฟอร์มอื่นต้องส่ง null)
  useEffect(() => {
    formGenerate.forEach((field: any) => {
      if (!field.visibleWhenLeaveFormIncludes) return;
      const selectedLeaveForm: any = dataLeaveForm.find(
        (lf: any) =>
          `${lf.id_leave_form}` ===
          `${inputValue?.[field.section]?.leave_type_form_template}`
      );
      const isMatchLeaveForm = selectedLeaveForm?.leave_form_name?.includes(
        field.visibleWhenLeaveFormIncludes
      );
      if (!isMatchLeaveForm && inputValue?.[field.section]?.[field.name]) {
        handleChange(field.section, field.name, "");
      }
    });
  }, [inputValue?.information?.leave_type_form_template, dataLeaveForm]);

  const renderField = (fieldConfig: any) => {
    const {
      label,
      name,
      placeholder,
      type,
      typeForm,
      style,
      responsive,
      isRequired,
      titleRequired,
      disable,
      section,
      optionName,
      radioName,
      isCheck,
      defaultOption,
    } = fieldConfig;

    // แสดง field นี้เฉพาะเมื่อรูปแบบฟอร์มที่เลือกมีชื่อตรงเงื่อนไข
    // (เช่น หมวดหมู่การลา แสดงเฉพาะฟอร์ม "ใบลาอาพาธ/ป่วย ลากิจ ลาคลอดบุตร")
    if (fieldConfig.visibleWhenLeaveFormIncludes) {
      const selectedLeaveForm: any = dataLeaveForm.find(
        (lf: any) =>
          `${lf.id_leave_form}` ===
          `${inputValue[section]?.leave_type_form_template}`
      );
      const isMatchLeaveForm = selectedLeaveForm?.leave_form_name?.includes(
        fieldConfig.visibleWhenLeaveFormIncludes
      );
      if (!isMatchLeaveForm) {
        return null;
      }
    }

    switch (type) {
      case "input":
        return (
          <Grid
            item
            xs={responsive.sm}
            md={responsive.md}
            lg={responsive.lg}
            key={name}
            sx={{
              alignSelf: "end",
            }}
          >
            <InputTextField
              heading={t(label)}
              placeholder={t(placeholder)}
              value={
                // concatWith (opt-in): แสดงค่ารวมกับอีก field (เว้นวรรค) สำหรับ field อ่านอย่างเดียว
                // โดยที่ state ยังแยกเก็บทีละ field (เช่น spouse + spouse_last_name)
                fieldConfig.concatWith
                  ? [
                      inputValue[section][name],
                      inputValue[section][fieldConfig.concatWith],
                    ]
                      .filter(Boolean)
                      .join(" ")
                  : inputValue[section][name]
              }
              onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleChange(section, name, e.target.value)
              }
              markRequired={isRequired}
              helperText={
                isRequired &&
                  handleCheckValid &&
                  inputValue[section][name] === ""
                  ? t(titleRequired)
                  : ""
              }
              disabled={disable || !isCanEdit}
              style={style}
              type={typeForm}
            />
          </Grid>
        );
      case "textarea":
        return (
          <Grid
            item
            xs={responsive.sm}
            md={responsive.md}
            lg={responsive.lg}
            key={name}
            sx={{
              alignSelf: "end",
            }}
          >
            <InputTextField
              heading={t(label)}
              placeholder={t(placeholder)}
              value={inputValue[section][name]}
              onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleChange(section, name, e.target.value)
              }
              markRequired={isRequired}
              helperText={
                isRequired &&
                  handleCheckValid &&
                  inputValue[section][name] === ""
                  ? t(titleRequired)
                  : ""
              }
              disabled={disable || !isCanEdit}
              style={style}
              type={typeForm}
              row={3}
              maxRows={5}
              disablePaddingMultiline
              multiline
              inputHeight={"auto"}
            />
          </Grid>
        );
      case "date":
        return (
          <Grid
            item
            xs={responsive.sm}
            md={responsive.md}
            lg={responsive.lg}
            key={name}
            sx={{
              alignSelf: "end",
            }}
          >
            <InputDatePicker
              heading={t(label)}
              placeholder={t(placeholder)}
              value={inputValue[section][name]}
              onChange={(e: any) => handleChange(section, name, e)}
              helperText={
                isRequired &&
                  handleCheckValid &&
                  inputValue[section][name] === ""
                  ? t(titleRequired)
                  : ""
              }
              disabled={disable || !isCanEdit}
            />
          </Grid>
        );

      case "date-range":
        return (
          <Grid
            item
            xs={responsive.sm}
            md={responsive.md}
            lg={responsive.lg}
            key={name}
            sx={{
              alignSelf: "end",
              padding: 0,
            }}
          >
            <InputNewRangePicker
              heading={t(label)}
              placeholder={t(placeholder)}
              value={inputValue[section][name]}
              onchange={(e: any) => handleRangeDate(section, name, e)}
              onClear={(e: any) => handleClearRangeDate(section, name, e)}
              allowClear
              disabled={disable || !isCanEdit}
            />
          </Grid>
        );
      case "select":
        return (
          <Grid
            item
            xs={responsive.sm}
            md={responsive.md}
            lg={responsive.lg}
            key={name}
            sx={{
              alignSelf: "end",
            }}
          >
            <FilterSelect
              heading={t(label)}
              value={inputValue[section][name]}
              onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const selectedValue = e.target.value;
                handleChange(section, name, selectedValue);
                // เก็บ label ของ option ที่เลือกไว้ด้วย (opt-in ผ่าน storeLabelAs)
                // เพื่อให้แสดงข้อความได้แม้ option หลุดจาก list ภายหลัง (เช่น หลัง approve)
                if (fieldConfig.storeLabelAs) {
                  const selectedLabel =
                    getOptions(optionName).find(
                      (o: any) => `${o.value}` === `${selectedValue}`
                    )?.label ?? "";
                  handleChange(section, fieldConfig.storeLabelAs, selectedLabel);
                }
              }}
              helperText={
                isRequired &&
                  handleCheckValid &&
                  inputValue[section][name] === ""
                  ? t(titleRequired)
                  : ""
              }
              disabled={disable || !isCanEdit}
              style={style}
              options={(() => {
                const opts = getOptions(optionName);
                const currentValue = inputValue[section][name];
                const persistedLabel = fieldConfig.storeLabelAs
                  ? inputValue[section][fieldConfig.storeLabelAs]
                  : "";
                // ถ้าค่าที่เลือกไว้ไม่มีใน options ที่ดึงมา (เช่น หลุดจาก list หลัง approve)
                // ให้เติม MenuItem สำรองจาก label ที่เก็บไว้ เพื่อไม่ให้ select แสดงว่าง
                const isMissing =
                  currentValue !== "" &&
                  currentValue != null &&
                  !opts.some((o: any) => `${o.value}` === `${currentValue}`);
                const finalOpts =
                  isMissing && persistedLabel
                    ? [...opts, { value: currentValue, label: persistedLabel }]
                    : opts;
                return finalOpts.map((option: any) => (
                  <MenuItem value={option.value} key={option.value}>
                    {option.label}
                  </MenuItem>
                ));
              })()}
              labelId={""}
              selectId={""}
            />
          </Grid>
        );
      case "autocomplete":
        return (
          <Grid
            item
            xs={responsive.sm}
            md={responsive.md}
            lg={responsive.lg}
            key={name}
            sx={{
              alignSelf: "end",
            }}
          >
            <AutocompleteSelect
              labelId={"-"}
              options={getOptions(optionName)}
              heading={t(label)}
              getOptionLabel={(option: any) => option?.label || ""}
              // freeSolo
              // value={inputValue[section][name]}
              value={
                inputValue[section][name] && inputValue[section][name]["value"]
                  ? {
                    value: inputValue[section][name]["value"],
                    label:
                      getOptions(optionName).find(
                        (option: any) =>
                          parseInt(option?.value) ===
                          parseInt(inputValue[section][name]["value"])
                      )?.label || null,
                  }
                  : inputValue[section][name]
              }
              // onInputChange={}
              onChange={(_, value) => {
                handleChange(section, name, value);
              }}
              helperText={
                isRequired &&
                  handleCheckValid &&
                  inputValue[section][name] === ""
                  ? t(titleRequired)
                  : ""
              }
              disabled={disable || !isCanEdit}
            />
          </Grid>
        );
      case "checkbox-input":
        return (
          <Grid
            item
            xs={responsive.sm}
            md={responsive.md}
            lg={responsive.lg}
            key={name}
            sx={{
              display: "flex",
              alignItems: "end",
              gap: "16px",
            }}
          >
            <CheckBoxCustom
              checked={inputValue[section]["is_check_" + name]}
              label={t(label)}
              setChecked={(status: boolean) =>
                handleChange(section, "is_check_" + name, status)
              }
            />
            <InputTextField
              placeholder={t(placeholder)}
              value={inputValue[section][name]}
              onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleChange(section, name, e.target.value)
              }
              // markRequired={isRequired}
              helperText={
                isRequired &&
                  handleCheckValid &&
                  inputValue[section][name] === ""
                  ? t(titleRequired)
                  : ""
              }
              disabled={
                disable ||
                !isCanEdit ||
                !inputValue[section]["is_check_" + name]
              }
              style={style}
              type={typeForm}
            />
          </Grid>
        );
      case "radio-input":
        return (
          <Grid
            item
            xs={responsive.sm}
            md={responsive.md}
            lg={responsive.lg}
            key={name}
          >
            <div className="w-full">
              <RadioCustom
                disabled={disable || !isCanEdit}
                value={inputValue[section][name]}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  handleChange(section, name, e.target.value);
                  handleChange(section, "detail", "");
                  handleChange(section, "sub_detail", "");
                }}
                dataList={[
                  {
                    label: "ตามความตกลงระหว่าง",
                    value: "ตามความตกลงระหว่าง",
                    renderAfter: (
                      <div className="w-full flex justify-center items-center">
                        <InputTextField
                          placeholder={"placeholder"}
                          style={{
                            marginBottom: 2,
                          }}
                          disabled={
                            inputValue[section][name] !== "ตามความตกลงระหว่าง"
                          }
                          onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handleChange(section, "detail", e.target.value)
                          }
                          value={
                            inputValue[section][name] === "ตามความตกลงระหว่าง"
                              ? inputValue[section]["detail"]
                              : ""
                          }
                        />
                        <div className="px-2">กับ</div>
                        <InputTextField
                          placeholder={"placeholder"}
                          style={{
                            marginBottom: 2,
                          }}
                          disabled={
                            inputValue[section][name] !== "ตามความตกลงระหว่าง"
                          }
                          value={
                            inputValue[section][name] === "ตามความตกลงระหว่าง"
                              ? inputValue[section]["sub_detail"]
                              : ""
                          }
                          onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handleChange(section, "sub_detail", e.target.value)
                          }
                        />
                      </div>
                    ),
                  },
                  {
                    label: "ติดต่อเอง",
                    value: "ติดต่อเอง",
                    renderAfter: (
                      <InputTextField
                        placeholder={"ติดต่อเอง"}
                        style={{
                          marginBottom: 2,
                        }}
                        disabled={inputValue[section][name] !== "ติดต่อเอง"}
                        value={
                          inputValue[section][name] === "ติดต่อเอง"
                            ? inputValue[section]["detail"]
                            : ""
                        }
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          handleChange(section, "detail", e.target.value)
                        }
                      />
                    ),
                  },
                  {
                    label: "อื่นๆ",
                    value: "อื่นๆ",
                    renderAfter: (
                      <InputTextField
                        placeholder={"อื่นๆ"}
                        style={{
                          marginBottom: 2,
                        }}
                        value={
                          inputValue[section][name] === "อื่นๆ"
                            ? inputValue[section]["detail"]
                            : ""
                        }
                        disabled={inputValue[section][name] !== "อื่นๆ"}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          handleChange(section, "detail", e.target.value)
                        }
                      />
                    ),
                  },
                ]}
              />
            </div>
          </Grid>
        );
      case "input-array-period":
        return inputWorkPermitPeriod.map((periodItem, index) => (
          <Grid
            container
            item
            xs={12}
            key={index}
            alignItems="center"
            sx={{ marginBottom: 2 }}
          >
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
              ครั้งที่ {index + 1}
            </Typography>
            <Grid
              container
              item
              xs={12}
              direction="row"
              spacing={2}
              alignItems="center"
            >
              <Grid item xs={4}>
                <InputNewRangePicker
                  heading="ช่วงวันที่"
                  value={
                    Array.isArray(periodItem.period_date)
                      ? periodItem.period_date
                      : []
                  }
                  onchange={(e: any) =>
                    handleChangePeriod(index, "period_date", [
                      e?.[0] ? moment(e[0]).format("YYYY-MM-DD") : "",
                      e?.[1] ? moment(e[1]).format("YYYY-MM-DD") : "",
                    ])
                  }
                  onClear={() => handleChangePeriod(index, "period_date", [])}
                  allowClear
                  disabled={false}
                />
              </Grid>
              <Grid item xs={4}>
                <InputTextField
                  heading="ตามคำสั่งมหาวิทยาลัยที่"
                  value={periodItem.description}
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChangePeriod(index, "description", e.target.value)
                  }
                  helperText=""
                  disabled={false}
                />
              </Grid>
              <Grid item xs={4}>
                <InputDatePicker
                  heading="ลงวันที่"
                  value={periodItem.ref_date}
                  onChange={(e: any) =>
                    handleChangePeriod(index, "ref_date", e)
                  }
                  helperText=""
                  disabled={false}
                />
              </Grid>
            </Grid>
          </Grid>
        ));

      case "divider":
        return (
          <Grid
            item
            xs={responsive.sm}
            md={responsive.md}
            lg={responsive.lg}
            key={name}
          >
            <Divider />
          </Grid>
        );
      case "free-space":
        return (
          <Grid
            item
            xs={responsive.sm}
            md={responsive.md}
            lg={responsive.lg}
            key={name}
          ></Grid>
        );
      case "header":
        return (
          <Grid
            item
            xs={responsive.sm}
            md={responsive.md}
            lg={responsive.lg}
            key={name}
          >
            <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold" }}>
              {t(label)}
            </Typography>
          </Grid>
        );
      default:
        return null;
    }
  };

  return (
    <Grid container spacing={2}>
      {formGenerate.map((fieldConfig: any) => renderField(fieldConfig))}
    </Grid>
  );
};

export default FormComponent;
